var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                limit: _vm.limitNumber,
                action: "",
                accept: "image/*",
                "http-request": _vm.uploadFile,
                "list-type": "picture-card",
                "auto-upload": true,
                "show-file-list": false,
                "on-preview": _vm.handlePictureCardPreview,
                "on-exceed": _vm.handleExceed,
                "before-remove": _vm.beforeRemove,
              },
            },
            [
              !_vm.imageUrl
                ? _c("div", { staticClass: "addbox" }, [
                    _c("img", {
                      staticClass: "addicon",
                      attrs: {
                        src: require("../../assets/icon_add_24hui@2x.png"),
                        alt: "",
                      },
                    }),
                  ])
                : _c("img", {
                    attrs: { src: _vm.imageUrl, width: "120", height: "120" },
                  }),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }